import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';
import AppDialog from '../AppDialog';

export default function ConfirmDeleteModal(props) {
    const { open, title, confirmText, handleConfirm, close, busy = false } = props;

    return (
        <AppDialog
            open={open}
            onClose={close}
            title={title}
            onSubmit={handleConfirm}
            submitText='Confirm'
            submitColor='error'
            busy={busy}
        >
            <Typography>{confirmText}</Typography>
        </AppDialog>
    );
}

ConfirmDeleteModal.propTypes = {
    open: PropTypes.bool.isRequired,
    title: PropTypes.string.isRequired,
    confirmText: PropTypes.string.isRequired,
    handleConfirm: PropTypes.func.isRequired,
    close: PropTypes.func.isRequired,
    busy: PropTypes.bool,
};